'use strict';

import AOS from 'aos';

const ELEMENTS_TO_DELAY = '.js--AOS-multiItemDelay';

function multiItemDelay() {
	const delayElements = document.querySelectorAll(ELEMENTS_TO_DELAY);
	let startDelay = 0;

	delayElements.forEach(element => {
		startDelay += 150;
		startDelay = (startDelay > 3000) ? 3000 : startDelay;
		element.setAttribute( 'data-aos-delay', startDelay );
	});
}
//

(function () {
	setTimeout(() => {
		AOS.init({
			once: true,
			duration: 1000
		});
	}, 20);

	if (ELEMENTS_TO_DELAY) multiItemDelay()

}());
